// How it works:
// 1) User checks a Size checkbox (trusted change event)
// 2) We stop theme handlers for that event, uncheck other Size boxes
// 3) We dispatch ONE synthetic change event on the clicked box
// 4) Theme sees only the synthetic event and serializes a clean single-size URL

(function () {
  const SIZE_PARAM = "filter.v.option.size";
  let isHandling = false;

  function allSizeCheckboxes() {
    return Array.from(
      document.querySelectorAll(
        'input[type="checkbox"][name="' + CSS.escape(SIZE_PARAM) + '"]'
      )
    );
  }

  function isSizeCheckbox(el) {
    return (
      el &&
      el.tagName === "INPUT" &&
      el.type === "checkbox" &&
      (el.name || "") === SIZE_PARAM
    );
  }

  // if URL already contains multiple size params, keep last once per page load.
  // If the theme re-adds multiple immediately after, we do NOT loop-replace endlessly.
  function normalizeUrlOnce() {
    try {
      if (sessionStorage.getItem("__pa_size_norm_done") === "1") return;
      const url = new URL(window.location.href);
      const all = url.searchParams.getAll(SIZE_PARAM);
      if (all.length <= 1) return;

      const keep = all[all.length - 1];
      url.searchParams.delete(SIZE_PARAM);
      url.searchParams.append(SIZE_PARAM, keep);

      sessionStorage.setItem("__pa_size_norm_done", "1");
      window.location.replace(url.toString());
    } catch (e) {
      // If sessionStorage is blocked, just skip normalization to avoid loops.
    }
  }

  function onChangeCapture(e) {
    // Only intercept real user interactions.
    // Our re-dispatched Event("change") is not trusted, so it will pass through to the theme.
    if (!e.isTrusted) return;

    const el = e.target;
    if (!isSizeCheckbox(el)) return;
    if (isHandling) return;

    // Only enforce when turning ON a size, allow turning OFF so no size selected
    if (!el.checked) return;

    isHandling = true;

    // Block the theme from handling THIS trusted event so it would serialize stale multi-check state
    e.stopImmediatePropagation();
    e.stopPropagation();

    // Ensure single-select state in the DOM
    const boxes = allSizeCheckboxes();
    boxes.forEach((cb) => {
      if (cb !== el) cb.checked = false;
    });

    // Let the theme handle exactly one synthetic change event
    // Use setTimeout(0) so we fully exit current event stack.
    setTimeout(() => {
      try {
        el.dispatchEvent(new Event("change", { bubbles: true }));
      } finally {
        isHandling = false;
      }
    }, 0);
  }

  normalizeUrlOnce();

  // Capture phase to run before theme bubbling handlers
  document.addEventListener("change", onChangeCapture, true);
})();